/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { Enabled } from './Enabled';
import { SubmissionValidatorInputData } from './SubmissionValidatorInputData';
const EnabledHandinRequirementsParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['version', /* #__PURE__ */ parsers.exactly('SubmissionValidator')],
    ['data', SubmissionValidatorInputData],
]), Enabled);
export class EnabledHandinRequirements extends Enabled {
    static decode(input) {
        return EnabledHandinRequirementsParser.decode(input).map(res => new EnabledHandinRequirements(res));
    }
    static unsafeDecode(input) {
        return EnabledHandinRequirements.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EnabledHandinRequirementsParser.encode(data);
    }
    static schema() {
        return EnabledHandinRequirementsParser.schema();
    }
}
